import { render, staticRenderFns } from "./inviteclientexample.vue?vue&type=template&id=681f5b80&"
import script from "./inviteclientexample.vue?vue&type=script&lang=js&"
export * from "./inviteclientexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports